import Blockly from "blockly";
import Schema from "../schema";

import { menu as room__enemies__effects } from './room_enemies_effects.js';

export const menu = {
  name: (<div className="text"><u>E</u>nemies</div>),
  trigger: 'e',
  children: {
    room__enemies__effects,
    'room_spawn': {
      name: (<div className="text"><u>S</u>pawn Item/Enemey</div>),
      trigger: 's',
    },
    'room_respawn': {
      name: (<div className="text"><u>R</u>espawn enemies</div>),
      trigger: 'r',
    },
    'room_kill': {
      name: (<div className="text"><u>K</u>ill all enemies</div>),
      trigger: 'k',
    },
  }
}

/* ****************************************************************************************************************
 * NOTE: See room.js for shared command definition for "room_spawn"
 ******************************************************************************************************************/

/* ****************************************************************************************************************
 * Respawn the enemies of the current room
 ******************************************************************************************************************/
Blockly.Blocks['room_respawn'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Respawn enemies in the current room.')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Respawn the enemies of the current room.')
  }
}

Blockly.JSON['room_respawn'] = (block) => {
  return {
    action: 'room_respawn',
  }
}

Schema.registerAction('room_respawn', {
  "if": {
    "properties": {
      "action": {
        "const": "room_respawn"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Kill the enemies of the current room
 ******************************************************************************************************************/
Blockly.Blocks['room_kill'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Kill all enemies in the current room.')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Kills all the enemies in the current room.')
  }
}

Blockly.JSON['room_kill'] = (block) => {
  return {
    action: 'enemy_apply_status',
    params: {
      "status": "kill",
    }
  };
}
